import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    gameCode: "", //
    id: "", //游戏id
    museumCode: "", //场馆code
    phoneNumber: '',//手机号
    bgImg: '',//背景图
    bgImg2: '',//背景图
    correctImg: '',//正确图
    errorImg: '',//错误图
    submitLimit: null,//限制答题次数
    prizeHint: null,//领奖提示
    platform: 'mobilePhone',//平台
    isLogin: false,//是否登录
    settingData: {},
    museumLogo: '',
    totalCount: null,
    themeImgs: [],
    showName: false,
    showUnit: false,
    name: '',
    unit: ''
  },
  mutations: {},
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js